import { default as axios } from "./config.js";

export default {
	// Auth
	loginApi: (params) => axios.post("login", params),
	logoutApi: (sid) => axios.post("logout", { sid }),
	sendmail: (params) => axios.post("sendmail", params),
	suggestion: (params) => axios.post("suggestions", params),
	getUTCDateTime: () => axios.get("utc-datetime-get"),

	postApplication: (formData) => {
		return axios.post("applications", formData);
	},
};
